// extracted by mini-css-extract-plugin
module.exports = {"h1":"H1_h1__107uJ","semi-bold":"H1_semi-bold__2wiZx"};